export default "__VITE_ASSET__CqyoPOKe__"